import { withPrefix } from 'gatsby-link';
import React from 'react';

import { ActionButton } from '@/components/ActionButton';

import styles from './BottomCard.styles';

const BottomCard = ({ data, btnText, url }) => {
  const { title, img, imgMobile, text, alt } = data;

  return (
    <div css={styles}>
      <p className="cardTitle">{title}</p>
      <div className="cardInfo">
        <div className="cardImg-container">
          <img className="cardImg" src={withPrefix(img)} alt={alt} />
          <img className="cardImgMobile" src={withPrefix(imgMobile)} alt={alt} />
        </div>
        <div className="cardInfo-text">
          <p className="cardText">{text}</p>
          <div className="btn-container">
            <ActionButton href={url} buttonSign={btnText} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BottomCard;
